import { render, staticRenderFns } from "./KnowledgeBaseArchivesDetail.vue?vue&type=template&id=38ab01f8&scoped=true"
import script from "./KnowledgeBaseArchivesDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseArchivesDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseArchivesDetail.vue?vue&type=style&index=0&id=38ab01f8&prod&lang=css"
import style1 from "./KnowledgeBaseArchivesDetail.vue?vue&type=style&index=1&id=38ab01f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ab01f8",
  null
  
)

export default component.exports